import React from 'react';
import { Eyebrow } from './Eyebrow';
const metrics = [{
  value: '240+',
  label: 'Practical pages'
}, {
  value: '50',
  label: 'Ready-to-play jazz exercises'
}, {
  value: '6',
  label: 'Free bonus gifts'
}, {
  value: '6',
  label: 'Complete volumes'
}];
const coverage = ['Beginner Foundations', 'Intermediate Standards', 'Advanced Improvisation', 'All Solo & Group Settings', 'Games & Ensemble Play', 'Assessment & Progress Tracking'];
export function SystemOverview() {
  return <section aria-labelledby="system-heading" className="bg-night py-16 sm:py-24" data-id="element-319" data-mp="pwwoclt26mer">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-320" data-mp="13vwfq17yhfem">
        <div className="grid items-center gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,26rem)] lg:gap-16" data-id="element-321" data-mp="13xha9qu9sych">
          <div data-id="element-322" data-mp="yvrz8b71skoe">
            <Eyebrow data-id="element-323" data-mp="yzfqf3p0suzy">The most complete system for jazz guitar educators</Eyebrow>
            <h2 id="system-heading" className="mt-5 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-324" data-mp="2f9i5noln3l17">
              Jazz Teacher&rsquo;s <span className="text-amber" data-id="element-325" data-mp="235kujijlsy18">Arsenal&trade;</span>
            </h2>
            <p className="mt-6 max-w-xl font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-326" data-mp="284nxmxg0wu6k">
              Over 240 pages of complete lesson plans, professional exercises, standards, technique
              guides, and classroom management tools &mdash; everything already prepared for you.
            </p>

            <dl className="mt-10 grid grid-cols-2 gap-y-8 border-t border-night-600 pt-8 sm:grid-cols-4" data-id="element-327" data-mp="1kh7gmqy7klux">
              {metrics.map(metric => <div key={metric.label} data-id="element-328" data-mp="1ue2hhghyeycd">
                  <dt className="sr-only" data-id="element-329" data-mp="1ud10kve9bhmq">{metric.label}</dt>
                  <dd data-id="element-330" data-mp="1z4isktyay7vk">
                    <span className="block font-display text-4xl leading-none text-amber sm:text-5xl" data-id="element-331" data-mp="1z50wmcr7hqe1">
                      {metric.value}
                    </span>
                    <span className="mt-2 block max-w-[9rem] text-[11px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-332" data-mp="16ohvspuf1mze">
                      {metric.label}
                    </span>
                  </dd>
                </div>)}
            </dl>
          </div>

          <div className="rounded-2xl border border-night-600 bg-night-800 p-7 sm:p-8" data-id="element-333" data-mp="tmuw6bgh2f5p">
            <p className="text-[11px] font-semibold uppercase tracking-label text-amber" data-id="element-334" data-mp="18fobnwvquvad">
              Total coverage
            </p>
            <p className="mt-2 font-display text-2xl leading-tight text-cream" data-id="element-335" data-mp="foo3d9qdr5cw">
              Beginner through advanced jazz
            </p>
            <ul className="mt-6 divide-y divide-night-600" data-id="element-336" data-mp="ar4piaxlgulh">
              {coverage.map((item, index) => <li key={item} className="flex items-baseline gap-4 py-3.5 text-sm text-cream-soft first:pt-0 last:pb-0" data-id="element-337" data-mp="poopf3fmvzks" data-mpi={index}>
                  <span className="tabular-nums text-xs font-semibold text-amber" data-id="element-338" data-mp="2117sqv312ox9">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}